// Sites Enums
const BASIC = 'Básico';
const PREMIUM = 'Personalizado';
const PRO = 'Pro';
// Page
const HOME = 'Home';
const STOCK = 'Estoque';
const FINANCING = 'Financiamento';
const COMPANY = 'Empresa';
const CONTACT = 'Contato';
const SERVICES = 'Serviços';
const AFTER_SALES = 'Pós-venda';
const TEST_DRIVE = 'Test-Drive';
const CATALOG = 'Catálogo ZeroKm';
const OUR_STORES = 'Nossas lojas (Visão de grupo)';
// Layout
const BASIC_LAYOUT = 'Layout Básico';
const PREMIUM_LAYOUT = 'Layout Premium';
const PRO_LAYOUT = 'Layout Pro';
// Features
const SITE_BUILDER = 'Site Builder Exclusivo';
const NEW_PAGES = 'Inclusão de novas páginas';
const VIDEOS = 'Inclusão de vídeos';
const SOCIAL_NETWORKS = 'Redes Sociais';
const WHATSAPP = 'WhatsApp';
const DAILY_BACKUPS = 'Backups diários';
const RESPONSIVE_DESIGN = 'Design responsivo';
const FEATURED_GALLERY = 'Galeria de destaque';
const TAGS_MANAGER = 'Gerenciador de Tags';
const MULTIPLE_DOMAINS = 'Suporte a múltiplos domínios';
// SEO
const SITEMAPS = 'Sitemaps';
const META_DESCRIPTION = 'Meta descriptions';
const HTTPS_SSL = 'Site Seguro HTTPS/SSL';
// Others
const SUPPORT = 'Suporte especializado';
const PREMIUM_HOST = 'Hospedagem Premium';
const GOOGLE_ANALYTICS = 'Google Analítics';
const THIRD_PARTY = 'Integração Terceiros (E-mail, Chat, Notícias, etc.)';

const SITE_ENUMS = {
    BASIC,
    PREMIUM,
    PRO,
    HOME,
    STOCK,
    FINANCING,
    COMPANY,
    CONTACT,
    SERVICES,
    AFTER_SALES,
    TEST_DRIVE,
    CATALOG,
    OUR_STORES,
    BASIC_LAYOUT,
    PREMIUM_LAYOUT,
    PRO_LAYOUT,
    SITE_BUILDER,
    NEW_PAGES,
    VIDEOS,
    SOCIAL_NETWORKS,
    WHATSAPP,
    DAILY_BACKUPS,
    RESPONSIVE_DESIGN,
    FEATURED_GALLERY,
    TAGS_MANAGER,
    MULTIPLE_DOMAINS,
    SITEMAPS,
    META_DESCRIPTION,
    HTTPS_SSL,
    SUPPORT,
    PREMIUM_HOST,
    GOOGLE_ANALYTICS,
    THIRD_PARTY,
};

export default SITE_ENUMS;
